export default __webpack_public_path__ + "static/media/Tea & Coffee.f875ef75.png";